import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AuditLogsAPI from '../../api/auditLogs';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    perPage: 15,
    totalEntries: 0,
  },
  filters: {
    userId: null,
    auditableType: null,
    from: null,
    to: null,
  },
  uiFlags: {
    fetchingList: false,
    exporting: false,
  },
};

const getters = {
  getAuditLogs(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getFilters(_state) {
    return _state.filters;
  },
};

const actions = {
  setFilters({ commit }, filters) {
    commit(types.default.SET_AUDIT_LOGS_FILTERS, filters);
  },

  async fetch({ commit, state: localState }, { page } = {}) {
    commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: true });
    try {
      const { userId, auditableType, from, to } = localState.filters;
      const response = await AuditLogsAPI.get({
        page,
        userId,
        auditableType,
        from,
        to,
      });
      const { audit_logs: logs = [] } = response.data;
      const {
        total_entries: totalEntries,
        per_page: perPage,
        current_page: currentPage,
      } = response.data;
      commit(types.default.SET_AUDIT_LOGS, logs);
      commit(types.default.SET_AUDIT_LOGS_META, {
        totalEntries,
        perPage,
        currentPage,
      });
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return logs;
    } catch (error) {
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },

  async export({ commit, state: localState }) {
    commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { exporting: true });
    try {
      const { userId, auditableType, from, to } = localState.filters;
      const response = await AuditLogsAPI.export({
        userId,
        auditableType,
        from,
        to,
      });
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_AUDIT_LOGS_UI_FLAG, { exporting: false });
    }
  },
};

const mutations = {
  [types.default.SET_AUDIT_LOGS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_AUDIT_LOGS]: MutationHelpers.set,
  [types.default.SET_AUDIT_LOGS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.default.SET_AUDIT_LOGS_FILTERS](_state, data) {
    _state.filters = {
      ..._state.filters,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
